<template>
	<div />
</template>

<script lang="ts" setup>
import type { ColumnConfig } from "./types";

interface TableColumnProps {
	label?: string;
	prop?: string | Array<string>;
	sortable?: boolean;
	mobileConfig?: ColumnConfig["mobileConfig"];
	type?: ColumnConfig["type"];
	width?: ColumnConfig["width"];
	customizedSorter?: ColumnConfig["customizedSorter"];
	hidden?: boolean;
}
const props = defineProps<TableColumnProps>();
// Inject columns state from ancestor
const columns = inject<Ref<ColumnConfig[]>>("columnsRef");
const slots = useSlots();
onMounted(() => {
	if (columns?.value) {
		columns.value.push({
			label: props.label || "",
			prop: props.prop || "",
			sortable: props?.sortable || false,
			type: props?.type || undefined,
			width: props?.width,
			customizedSorter: props?.customizedSorter,
			hidden: props?.hidden,
			mobileConfig: {
				order: props?.mobileConfig?.order || 0,
				isHeader: props?.mobileConfig?.isHeader || false,
				showLabel: props?.mobileConfig?.showLabel || false,
				isAttachmentCol: props?.mobileConfig?.isAttachmentCol || false,
				fluid: props?.mobileConfig?.fluid === undefined ? true : props?.mobileConfig?.fluid,
				type: props?.mobileConfig?.type || undefined,
				hidden: props?.mobileConfig?.hidden,
			},
			render: rawData => {
				try {
					let children = [];
					const { index, row, column } = rawData;
					if (slots?.default) {
						// it is possible default slot has multiple children, get all children and render in a block
						const defaultSlots = slots?.default({
							index,
							row,
							column,
						});
						defaultSlots.forEach(item => children.push(item));
					} else {
						children = row[column.prop];
					}
					return h("div", children);
				} catch (err) {
					return h("div", []);
				}
			},
		});
	}
});
</script>
